import { Box } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const CollapseToggle = ({ open, setOpen }) => {
  return (
    <Box
      onClick={() => setOpen(!open)}
      sx={{
        display: { xs: "none", sm: "flex" },
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%"
      }}
    >
      {open ? (
        <ChevronRight sx={{ color: "white" }} />
      ) : (
        <ChevronLeft sx={{ color: "white" }} />
      )}
    </Box>
  );
};

export default CollapseToggle;